import SamaritanFetch from './httpClient';

export const fetchPreviousTouchpointAnswers = (homeless_id: number) =>
    SamaritanFetch.v3('/touchpoints', {
        query: {
            'touchpoint[homeless_id]': homeless_id,
            'touchpoint[relations][touchpoint_answers][dumbHack]': ''
        }
    });
